/** authen account url */
export const AccountURL = {
    signin: 'Signin',
    forgotPassword: 'Forgot-Password',
    signup: 'Signup'
};